import React from 'react';
import { Alert, Box, Button, Stack } from '@mui/material';
import SystemTabs from '../../../ui/SystemTabs';
import CabecalhoTab from './tabs/CabecalhoTab';
import DocumentosTab from './tabs/DocumentosTab';
import ComissaoTab from './tabs/ComissaoTab';
import ChapasTab from './tabs/ChapasTab';
import ResultadoTab from './tabs/ResultadoTab';

export default function Form({ cadastro, comissao, documentos, chapas, resultado, permissoes, parametro, isMobile }) {
    const ocupado = cadastro.isSubmitting || documentos.ocupado || chapas.ocupado || resultado.ocupado;
    const bloqueado = !cadastro.podeSalvar || ocupado;
    return (
        <Box
            component="form"
            onSubmit={(e) => {
                if (ocupado) {
                    e.preventDefault();
                    return;
                }
                cadastro.salvar(e, comissao.pendente || documentos.pendente || chapas.pendente || resultado.pendente);
            }}
            sx={{ minWidth: 0 }}
        >
            <h1>Eleição</h1>
            {!cadastro.podeSalvar && <Alert severity="info">Consulta sem permissão de alteração.</Alert>}
            <SystemTabs
                initialKey="cabecalho"
                tabs={[
                    {
                        key: 'cabecalho',
                        label: 'Cabeçalho',
                        panel: (
                            <CabecalhoTab
                                dados={cadastro.dados}
                                empresas={cadastro.empresas}
                                alterar={cadastro.alterar}
                                bloqueado={bloqueado}
                                editando={cadastro.editando}
                            />
                        ),
                    },
                    {
                        key: 'comissao',
                        label: 'Comissão Eleitoral',
                        panel: (
                            <ComissaoTab
                                membros={cadastro.dados.comissao}
                                modulo={comissao}
                                ocupado={ocupado}
                                bloqueado={bloqueado}
                                parametro={parametro}
                                isMobile={isMobile}
                            />
                        ),
                    },
                    {
                        key: 'chapas',
                        label: 'Chapas',
                        panel: (
                            <ChapasTab
                                modulo={chapas}
                                eleicaoUuid={cadastro.dados.uuid}
                                permissoes={permissoes}
                                parametro={parametro}
                                isMobile={isMobile}
                                bloqueado={cadastro.isSubmitting || documentos.ocupado || resultado.ocupado}
                            />
                        ),
                    },
                    {
                        key: 'resultado',
                        label: 'Resultado',
                        panel: (
                            <ResultadoTab
                                modulo={resultado}
                                eleicaoUuid={cadastro.dados.uuid}
                                parametro={parametro}
                                isMobile={isMobile}
                                bloqueado={cadastro.isSubmitting || documentos.ocupado || chapas.ocupado}
                            />
                        ),
                    },
                    {
                        key: 'documentos',
                        label: 'Documentos',
                        panel: (
                            <DocumentosTab
                                modulo={{ ...documentos, ocupado: documentos.ocupado || resultado.ocupado }}
                                eleicaoUuid={cadastro.dados.uuid}
                                permissoes={permissoes}
                                parametro={parametro}
                                isMobile={isMobile}
                            />
                        ),
                    },
                ]}
            />
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    disabled={ocupado}
                    onClick={() => {
                        if (
                            (chapas.pendente || resultado.pendente) &&
                            !window.confirm('Sair e descartar as alterações não salvas da chapa ou da apuração?')
                        )
                            return;
                        cadastro.voltar();
                    }}
                >
                    Voltar
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={bloqueado || comissao.pendente || documentos.pendente || chapas.pendente || resultado.pendente}
                >
                    {cadastro.isSubmitting ? 'Salvando...' : cadastro.editando ? 'Atualizar' : 'Cadastrar'}
                </Button>
            </Stack>
        </Box>
    );
}
